module.exports = __webpack_public_path__ + "img/equatePlus.8ef24f3e.png";